import { useTranslation } from '../../lib/i18n';
import AuthForm from '../forms/auth-form';

const ChooseLogin = ({ advance, className = '' }) => {
  const { t } = useTranslation();
  return (
    <div className={`${className} mx-auto max-w-xl p-8 pb-0 text-center`}>
      <AuthForm loginDescription={t('chooseLoginText')}>
        <div className='mt-8 border-t border-0.3 pt-8'>
          <button
            type='button'
            onClick={advance}
            className='flex w-full justify-center rounded-md border border-input border-opacity-70 px-3 py-2 transition duration-200 hover:bg-black hover:text-white'
          >
            {t('continueAsGuest')}
          </button>
        </div>
      </AuthForm>
    </div>
  );
};

export default ChooseLogin;
